import { render } from "./UpdateProductStockModal.vue?vue&type=template&id=6a2dd1b1&scoped=true"
import script from "./UpdateProductStockModal.vue?vue&type=script&lang=js"
export * from "./UpdateProductStockModal.vue?vue&type=script&lang=js"

import "./UpdateProductStockModal.vue?vue&type=style&index=0&id=6a2dd1b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2dd1b1"]])

export default __exports__